export const INDIVIDUAL = 'individual';
export const INSTRUCTOR = 'instructor';
export const MEMBER = 'member';
export const STUDENT = 'student';

export const seatTypes = [ INDIVIDUAL, INSTRUCTOR, MEMBER, STUDENT ];
